
import { useNavigation } from '@react-navigation/native';
import { APIData } from '../constants';
import useRest from './base/useRest';

// CHARTS

const preffix = "charts";

export const useChart = (options?: APIData) => {
    return useRest(`${preffix}/`, options);
};
